import React, { useEffect, useState } from 'react'
import '../assets/styles/modal.scss'
import { useTranslation } from 'react-i18next';

export const DeleteConf = (props) => {
  console.log(props)
  const { t } = useTranslation();
  const [isError, setIsError] = useState(false)
  const [updateStatusText, setUpdateStatusText] = useState("")

  
  useEffect(() => {
    if (props.modalFormStatusObj) {
      if (('text' in props.modalFormStatusObj)) {
        setUpdateStatusText(props.modalFormStatusObj.text);
      }
      else if (('error' in props.modalFormStatusObj)) {
        setUpdateStatusText(props.modalFormStatusObj.error);
        setIsError(props.modalFormStatusObj.error)
      }
    };
  }, [props.modalFormStatusObj])

  const onClickDelete = () => {
    props.onCloseDelete()
    removeContainerOverlay()
  }

  const removeContainerOverlay = () => {
    /**
     * Remove overlay to parent class
     */
    (document.querySelectorAll('.content-container')[0]).classList.remove('modal-overlay-bg2');
  };

  return (
    <div className="cfg-modal-backdrop" style={{ zIndex: '99999' }}>
      <div className="cfg-modal" style={{ maxWidth: '500px', width: '90vw' }}>
 
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: props?.title ? 'space-between' : 'flex-end', paddingBottom: '12px', borderBottom: '1px solid rgba(40,80,140,0.3)', marginBottom: '16px', padding: '16px 24px' }}>
        {props?.title ?  <h2 className="dialog__title subheading-text-medium fontMedium" style={{ margin: 0 }}>
            {'Delete - '+props.title}
          </h2> : <></>}
          <button 
            type="button" 
            className="cfg-modal-close" 
            onClick={onClickDelete} 
            aria-label="Close"
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#8aaacf', 
              fontSize: '24px', 
              cursor: 'pointer', 
              padding: 0, 
              flexShrink: 0, 
              transition: 'color 0.2s ease' 
            }}
            onMouseEnter={(e) => e.target.style.color = '#ff6b6b'}
            onMouseLeave={(e) => e.target.style.color = '#8aaacf'}
          >
            ×
          </button>
        </div>
 
        <div className="cfg-modal-body" style={{ padding: '16px 24px', minHeight: '120px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center', color: '#c9d1dc', fontSize: '14px', marginBottom: '16px' }}>
            {props.description}
          </div>

          {updateStatusText && (
            <div 
              className={"dialog__statusBlock " + (isError ? 'alert_error' : 'alert_success')}
              style={{
                width: '100%',
                padding: '12px 16px',
                marginBottom: '16px',
                borderRadius: '6px',
                fontSize: '13px',
                backgroundColor: isError ? 'rgba(220, 53, 69, 0.1)' : 'rgba(40, 167, 69, 0.1)',
                color: isError ? '#dc3545' : '#28a745',
                border: isError ? '1px solid rgba(220, 53, 69, 0.3)' : '1px solid rgba(40, 167, 69, 0.3)'
              }}
            >
              {updateStatusText}
            </div>
          )}
        </div>
 
        <div className="cfg-modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', padding: '16px 24px', borderTop: '1px solid rgba(40,80,140,0.3)' }}>

          <button 
            disabled={props.buttonStat ? props.buttonStat : false} 
            className={"btn btn-danger" + (props.state && props.state.deleteProg ? ' button_inrt' : '')}
            style={{ 
              padding: "10px 32px", 
              fontSize: "14px", 
              fontWeight: "600", 
              backgroundColor: (props.buttonStat || (props.state && props.state.deleteProg)) ? "rgba(230, 84, 76, 0.3)" : "#e05c5c", 
              border: "none", 
              color: (props.buttonStat || (props.state && props.state.deleteProg)) ? "rgba(255,255,255,0.5)" : "#ffffff", 
              borderRadius: "6px", 
              cursor: (props.buttonStat || (props.state && props.state.deleteProg)) ? "not-allowed" : "pointer", 
              transition: "all 0.2s",
              minWidth: "100px"
            }}
            onClick={props.onContinue}
          >
            {props.state && props.state.deleteProg ? 'Deleting...' : (t('buttons.delete') || 'Delete')}
          </button>
        </div>
      </div>
    </div>
  );
}
